import { render, staticRenderFns } from "./BaseStationCnxChart.vue?vue&type=template&id=36cca980&scoped=true&"
import script from "./BaseStationCnxChart.vue?vue&type=script&lang=ts&"
export * from "./BaseStationCnxChart.vue?vue&type=script&lang=ts&"
import style0 from "./BaseStationCnxChart.vue?vue&type=style&index=0&id=36cca980&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cca980",
  null
  
)

export default component.exports